import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Grid2 } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import LazyImage from "components/fileViewers/LazyImage";
import UploadFromDisk, { UPLOAD_TYPES } from "components/fileViewers/UploadFromDisk";
import UploadingImgPreview from "components/fileViewers/UploadingImgPreview";
import { assertArray } from "core/validation";
import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { API_URL } from "services";

import { actions } from "./form/logic/actions";
const useStyles = makeStyles((theme) => ({
    imgDiv: {
        width: "100%",
        minHeight: 100,
        "& > img": {
            width: "100%",
        },
    },
    formButtonsContainer: {
        width: "100%",
        textAlign: "right",
        display: "inline-flex",
        justifyContent: "flex-end",
        "& > button": {
            marginRight: theme.spacing(0.5),
        },
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
}));
function UserSignatureModal({ onClose, userId }) {
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [saving, setSaving] = useState(false);
    const fileId = file ? file.id : null;

    const dispatch = useDispatch();

    function handleClose() {
        if (!saving) {
            onClose();
        }
    }

    function onFileSelected(_files) {
        if (assertArray(_files) && !saving) {
            const _file = _files[0];
            _file.id = new Date().getTime();
            setPreviewUrl(window.URL.createObjectURL(_file));
            setFile(_file);
            setSaving(true);
            dispatch(
                actions.UPLOAD_SIGN.send({
                    file: _file,
                    userId,
                })
            );
        }
    }

    function handleUploaded(id, success) {
        setSaving(false);
        if (success) {
            toast.success("Signature was uploaded successfully ", {
                position: "top-right"
            });
        } else {
            toast.error("Error trying to upload signature ", {
                position: "top-right"
            });
        }
    }

    const MemoImg = useMemo(() => {
        if (previewUrl) {
            return <UploadingImgPreview previewUrl={previewUrl} onUploaded={handleUploaded} fileId={fileId} />;
        } else {
            const url = API_URL.user(`${userId}/signature`);
            return <LazyImage url={url} />;
        }
    }, [previewUrl, userId, fileId]);

    const classes = useStyles();
    return (
        (<Dialog
            disableBackdropClick={false}
            open
            disableEscapeKeyDown
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">
                <Typography variant="h6">Signature photo</Typography>
                <IconButton aria-label="close" className={classes.closeButton} disabled={saving} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    <Container>
                        <Grid2 container spacing={2}>
                            <Grid2 size={12}>
                                <div className={classes.imgDiv}>{MemoImg}</div>
                            </Grid2>

                            <Grid2 size={12}>
                                <Box className={classes.formButtonsContainer}>
                                    {}
                                    {}
                                    {}
                                    {}
                                    {}
                                    {}
                                    <UploadFromDisk
                                        uploadType={UPLOAD_TYPES.SIGNATURE}
                                        onFileSelected={onFileSelected}
                                        trigger={
                                            <Button variant={"outlined"} disabled={saving} color={"primary"}>
                                                Upload new signature
                                            </Button>
                                        }
                                        componentView={<></>}
                                    ></UploadFromDisk>
                                    {}
                                    {}
                                    {}
                                    {}
                                    {}
                                    {}
                                    {}
                                </Box>
                            </Grid2>
                        </Grid2>
                    </Container>
                </DialogContentText>
            </DialogContent>
        </Dialog>)
    );
}

UserSignatureModal.propTypes = {
    onClose: PropTypes.func,
    userId: PropTypes.string,
};

export default UserSignatureModal;
